/*** AUTO REGISTER COMPONENTS START ***/
import { Factory } from "../../Factory";
import * as _ from "./index";
let _registed = false
export const regist_components = () => {
  if (_registed) return;
  _registed = true;
  [
    _.Alignment,
    _.ArrowSwitcher,
    _.BGMSwitcher,
    _.BackgroundSwitcher,
    _.CameraCtrl,
    _.CharMenuHead,
    _.CharMenuLogic,
    _.ComponentsPlayer,
    _.DanmuGameLogic,
    _.DemoModeLogic,
    _.Dialogs,
    _.DifficultyText,
    _.EndingPageLogic,
    _.ExtraZipText,
    _.FadeInOpacity,
    _.FadeOutOpacity,
    _.FighterHead,
    _.FighterName,
    _.FighterStatBar,
    _.FighterThumb,
    _.FitChildren,
    _.Flex,
    _.FlexItem,
    _.FnKeysCounts,
    _.FocusBehavior,
    _.GamePrepareLogic,
    _.HideWhenDialoging,
    _.HorizontalLayout,
    _.HoverBehavior,
    _.ImgLoop,
    _.IntegerPicker,
    _.Jalousie,
    _.LabelButton,
    _.LaunchPage,
    _.LittleFunnyAutoGame,
    _.LoadingContentText,
    _.MainMenuLogic,
    _.MiscSettingsLogic,
    _.MoveTableLogic,
    _.OpacityAnimation,
    _.OpacityFlash,
    _.OpacityHover,
    _.PauseHandling,
    _.Picture,
    _.PlayerCtrlType,
    _.PlayerKeyEdit,
    _.PlayerKeyText,
    _.PlayerName,
    _.PlayerNameInput,
    _.PlayerScore,
    _.PlayerScoreCell,
    _.PlayerScorePlayerName,
    _.PlayerTeamName,
    _.Players,
    _.PlayingTimeText,
    _.PositionAnimation,
    _.PrefixAndDifficultyText,
    _.RandomVisible,
    _.Reachable,
    _.ReachableGroup,
    _.ScaleAnimation,
    _.ScaleClickable,
    _.ScrollView,
    _.SettingsLogic,
    _.SineOpacity,
    _.SliderHandle,
    _.Sounds,
    _.StageModeLogic,
    _.StageSwitcher,
    _.StageTitleShow,
    _.StageTitleText,
    _.StageTransitions,
    _.SummaryLogic,
    _.SwitcherHandle,
    _.TeamSituationText,
    _.Tests,
    _.TextInput,
    _.VerticalLayout,
    _.VsModeLogic,
    _.WeaponRain,
    _.WrapContent
  ].map(v => Factory.register_component(v));
}
/*** AUTO REGISTER COMPONENTS END ***/